import markUrl from '../assets/brand/mark.svg';
import markSmallUrl from '../assets/brand/mark-small.svg';

/**
 * ItsAllPrep brand mark: a half-open pop-up book with a chessboard folding up out
 * of the gutter ("booking up" on your lines). Below 40px the small cut (tighter
 * crop, bigger board) keeps the board legible. Both SVGs sit under Vite's inline
 * limit, so they ship as data URIs with no extra request. They are generated from
 * a 3D model in `scripts/brand-mark.mjs` by `npm run brand:render`, which also
 * rebuilds the favicon and PNG icons.
 */
export function BrandMark({ size = 20 }: { size?: number }): JSX.Element {
  return <img src={size < 40 ? markSmallUrl : markUrl} width={size} height={size} alt="" />;
}
